// extracted by mini-css-extract-plugin
module.exports = {"btn-csv-rent":"RentabilidadeAnual_btn-csv-rent_2a3bV"};